import React from "react";

const IdTokenContext = React.createContext({
    idToken: null,
    setIdToken: () => { },
    clearIdToken: () => { },
});

export class IdTokenProvider extends React.Component {
    state = {
        idToken: null,
        setIdToken: (idToken) => this.setState({ idToken }),
        clearIdToken: () => this.setState({ idToken: null }),
    };

    render() {
        return (
            <IdTokenContext.Provider value={this.state}>
                {this.props.children}
            </IdTokenContext.Provider>
        );
    }
}

export default IdTokenContext;